import { render, staticRenderFns } from "./ServiceUpgrade.vue?vue&type=template&id=19fa6166&"
import script from "./ServiceUpgrade.vue?vue&type=script&lang=js&"
export * from "./ServiceUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./ServiceUpgrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports